<div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
  <div class="tw-flex tw-justify-between tw-w-full tw-px-4 tw-pt-4">
    <p><b>You already have an existing subscription request</b></p>
    <button class="tw-px-2" (click)="closeModal()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
  <div class="tw-max-w-xl tw-w-full tw-grow tw-p-4 tw-flex tw-flex-col">
    <p>Want to replace with selected car?</p>
    <div class="tw-flex tw-mt-2">
      <app-p3-button class="tw-w-full" (click)="confirm()">REPLACE</app-p3-button>
    </div>
  </div>